import React from "react"
import { Button } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import TooltipComponent from "./Tooltip"

const PageTitleButton = ({
  PagetitleText,
  HeaderButtonText,
  IconclassName,
  onClick,
  filterShow,
  filterClick,
  open,
  leftArrow,
  DropdownMenu
}) => {
  const navigate = useNavigate()
  const handleBack = () => {
    navigate(-1)
  }
  return (
    <div className="pagetitle_wrapper">
      <div className="d-inline-flex gap-2 align-items-center">
        {leftArrow && (
          <i
            className="icon_main backbutton_arrow left_arrow"
            onClick={handleBack}
          ></i>
        )}
        <h3 className="pgtitle_nm">{PagetitleText || "Default Title"}</h3>
      </div>
      <div className="buttonfilters_wrapper">
        {filterShow && (
          <TooltipComponent toolplace="left" tooltipText="Filter">
            <Button
              variant="outline-primary"
              className="filters_iconwrapper"
              onClick={filterClick}
              aria-controls="brand-filter-collapse"
              aria-expanded={open}
            >
              <i className="icon_main filter_funnel"></i>
            </Button>
          </TooltipComponent>
        )}
        {HeaderButtonText && (
          <Button
            variant="primary"
            className="d-inline-flex gap-2 align-items-center"
            onClick={onClick}
          >
            {IconclassName && (
              <i className={`icon_main plus_black ${IconclassName}`}></i>
            )}
            {HeaderButtonText}
          </Button>
        )}
        {DropdownMenu}
      </div>
    </div>
  )
}

export default PageTitleButton
